export default "__VITE_ASSET__GOWl09$N__"